import { RoutesAlias } from '../routesAlias'
import { AppRouteRecord } from '@/types/router'
/**
 * 菜单列表、异步路由
 *
 * 支持两种模式:
 * 1. 前端静态配置 - 直接使用本文件中定义的路由配置
 * 2. 后端动态配置 - 后端返回菜单数据，前端解析生成路由
 *
 * 菜单标题（title）:
 * 可以是 i18n 的 key，也可以是字符串，比如：'用户列表'
 */
export const asyncRoutes: AppRouteRecord[] = [
  {
    path: '/admin/inquiry_system',
    name: 'Inquiry_system',
    component: RoutesAlias.inquirySystem,
    meta: {
      title: '询单系统'
    }
  },
  {
    path: '/crmpc/customer/add',
    name: 'CrmpcustomerAdd',
    component: RoutesAlias.CrmpcustomerAdd,
    meta: {
      title: '新增客户资料',
      isHide: true
      // isHideTab: true
    }
  },
  {
    path: '/crmpc/customer/show',
    name: 'CrmpcustomerShow',
    component: RoutesAlias.CrmpcustomerShow,
    meta: {
      title: '客户资料',
      isHide: true
      // isHideTab: true
    }
  },
  {
    path: '/crmpc/customer/edit',
    name: 'CrmpcustomerEdit',
    component: RoutesAlias.CrmpcustomerEdit,
    meta: {
      title: '编辑客户资料',
      isHide: true
      // isHideTab: true
    }
  },
  {
    path: '/crmpc/customer/followadd',
    name: 'CustomerFollowAdd',
    component: RoutesAlias.CrmpcustomerFollowadd,
    meta: {
      title: '添加跟进',
      isHide: true
      // isHideTab: true
    }
  },
  {
    path: '/crmpc/recycle',
    name: 'Recycle',
    component: RoutesAlias.recycle,
    meta: {
      title: '回收站',
      isHide: true,
      keepAlive: true
    }
  },
  // 备货单相关路由
  {
    path: '/crmpc/stocking/stocking_list',
    name: 'StockingList',
    component: 'crmpc/stocking/stocking_list',
    meta: {
      title: '备货单列表',
      isHide: true
    }
  },
  {
    path: '/crmpc/stocking/Add',
    name: 'StockingAdd',
    component: 'crmpc/stocking/Add',
    meta: {
      title: '创建备货单',
      isHide: true,
      isHideTab: false,
      keepAlive: true
    }
  },
  {
    path: '/crmpc/stocking/show',
    name: 'StockingShow',
    component: 'crmpc/stocking/show',
    meta: {
      title: '备货单详情',
      isHide: true
    }
  },
  {
    path: '/crmpc/stocking/final_add',
    name: 'StockingFinalAdd',
    component: 'crmpc/stocking/final_add',
    meta: {
      title: '最终备货单',
      isHide: true,
      isHideTab: false,
      keepAlive: true
    }
  },
  {
    path: '/crmpc/stocking/final_show',
    name: 'StockingFinalShow',
    component: 'crmpc/stocking/final_show',
    meta: {
      title: '最终备货单详情',
      isHide: true
    }
  },
  //审批详情
  {
    path: '/crmpc/stocking/stocking_auth_detil',
    name: 'StockingAuth',
    component: 'crmpc/stocking/stocking_auth_detil',
    meta: {
      title: '最终备货单详情',
      isHide: true
    }
  },
  // 审批流程添加
  {
    path: '/admin/approval/approval_add',
    name: 'approvalAdd',
    component: 'admin/approval/approval_add',
    meta: {
      title: '审批流程添加',
      isHide: true
    }
  },
  {
    path: '/crmpc/approval/auth_detil',
    name: 'approvalDetil',
    component: 'crmpc/approval/auth_detil',
    meta: {
      title: '审核详情',
      isHide: true
    }
  },
  // 管理端备货单相关路由
  {
    path: '/admin/stock/stocking_list_admin',
    name: 'AdminStockingList',
    component: 'admin/stock/stocking_list_admin',
    meta: {
      title: '备货单列表',
      isHide: true
    }
  },
  {
    path: '/admin/stock/show_admin',
    name: 'AdminStockingShow',
    component: 'admin/stock/show_admin',
    meta: {
      title: '备货单详情',
      isHide: true
    }
  },
  {
    path: '/admin/stock/final_show_admin',
    name: 'AdminStockingFinalShow',
    component: 'admin/stock/final_show_admin',
    meta: {
      title: '最终备货单详情',
      isHide: true
    }
  }
]
